import React, { createContext, useContext, useEffect, useMemo, useRef } from 'react'
import { GameAudioManager } from '@/game/audioManager'

const GameAudioContext = createContext<GameAudioManager | null>(null)

export function GameAudioProvider({ children }: { children: React.ReactNode }) {
  const manager = useMemo(() => new GameAudioManager(), [])
  const done = useRef(false)

  useEffect(() => {
    const unlock = () => {
      if (done.current) return
      done.current = true
      void manager.unlock()
      window.removeEventListener('pointerdown', unlock)
      window.removeEventListener('keydown', unlock)
      window.removeEventListener('touchstart', unlock)
    }
    window.addEventListener('pointerdown', unlock)
    window.addEventListener('keydown', unlock)
    window.addEventListener('touchstart', unlock)
    return () => {
      window.removeEventListener('pointerdown', unlock)
      window.removeEventListener('keydown', unlock)
      window.removeEventListener('touchstart', unlock)
    }
  }, [manager])

  return <GameAudioContext.Provider value={manager}>{children}</GameAudioContext.Provider>
}

export function useGameAudio(): GameAudioManager {
  const ctx = useContext(GameAudioContext)
  if (!ctx) throw new Error('useGameAudio must be used within <GameAudioProvider>')
  return ctx
}
